export default {
  computed: {
    campaignNeedsApproval () {
      return this.$store.state.header?.headerData?.checkoutNeedsApproval ?? false
    }
  }
}
